import store from '@polleverywhere/redux'
import { slice as appSlice } from '../slices/app'

// Legacy navigation method to mimic backbone this.trigger('navigate') events.
// This allows newer redux apps to coexist with older backbone views that need to navigate and lets us migrate without breaking existing functionality.
export function navigate (page, options) {
  document.querySelector('pe-application')._pageOptions = options
  store.dispatch(appSlice.pageUpdated(page))
}
